import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchLinkedCompanies } from "../../../../services/projectsServices";
import Table from "../../../../components/table/table";
import { linkedProjectPlansColumns } from "./columns";
import { getMaterialsBudget, getServiceBudget } from "./linked-projects.utils";

const LinkedProjects = ({ companyID }) => {
    const { data: linkedProjects, isLoading } = useQuery({
        queryKey: ["linked-projects", companyID],
        queryFn: () => fetchLinkedCompanies(companyID),
    });
      

  if (isLoading) {
    return <div>Loading linked projects...</div>;
  }

  // Calculate footer totals (projectTotal is services + materials; materials is a line-item array)
  const totalServices = linkedProjects?.reduce((sum, project) => sum + getServiceBudget(project), 0);
  const totalMaterials = linkedProjects?.reduce(
    (sum, project) => sum + getMaterialsBudget(project.materials),
    0,
  );
  const totalSum = linkedProjects?.reduce(
    (sum, project) => sum + (parseFloat(project.projectTotal) || 0),
    0,
  );

  return (
    <Table
      data={linkedProjects || []}
      columns={linkedProjectPlansColumns(totalServices, totalMaterials, totalSum)}
      title="Linked Projects"
      sortable
      stickyHeader={true}
      hasFooter={true} 
    />
  );
};

export default LinkedProjects;
